import { Component, OnInit, ViewChild } from '@angular/core';
import { InfoComponent } from '../../objects/info/info/info.component';
import { LoadingComponent } from '../../objects/loading/loading.component';
import { AlertComponent } from '../../objects/alert/alert/alert.component';
import { AuthService } from 'src/app/Service/auth.service';
import { DataService } from 'src/app/Service/data.service';
import { NotifyService } from 'src/app/Service/notify.service';
import { Usuario } from 'src/app/Models/usuario/usuario';
import { Factura } from 'src/app/Models/factura/factura';
import { NothingComponent } from '../../objects/nothing/nothing.component';
import { VentasComponent } from '../ventas/ventas.component';

@Component({
  selector: 'app-ventas-detallado',
  templateUrl: './ventas-detallado.component.html',
  styleUrls: ['./ventas-detallado.component.css']
})
export class VentasDetalladoComponent implements OnInit {
  @ViewChild(AlertComponent, null) alert: AlertComponent;
  @ViewChild(LoadingComponent, null) loading: LoadingComponent;
  @ViewChild(NothingComponent, null) public nothing: NothingComponent;
  @ViewChild(InfoComponent, null) info: InfoComponent;
  
  public usuario:Usuario=new Usuario();
  public facturas:Factura[]=[];
  public pagventas:any;
  public totalventas:number = 0;
  public totalefectivo:number = 0;
  public totaltarjetas:number = 0;
  constructor(private data: DataService, private notify: NotifyService,private auth:AuthService) { }

  ngOnInit() {
    this.usuario = this.auth.getCurrentUser();
    this.GetData();
    
  }

  GetData(){
    this.loading.show('cargando datos');
    this.data.GetSimple(this.data.api.factura).subscribe(r => {
      if (r.length < 1) {
          console.log(r);
          this.facturas=[];
      }else{
          this.facturas=r;
          this.loading.hide();
      }
    }, e => { console.log(e); },()=>this.GetTotalVentas());
  }

  GetTotalVentas(){
    this.facturas.forEach(factura => {
      this.totalventas+= +factura.total
      this.totalefectivo+= +factura.efectivo
      this.totaltarjetas+= +factura.tarjetachq
    });
  }

}
